import { commonjsRequire } from '../../../_virtual/_commonjs-dynamic-modules.js';
import { __require as requireCloneDeep } from '../../lodash/cloneDeep.js';
import { __require as requireConstant } from '../../lodash/constant.js';
import { __require as requireDefaults } from '../../lodash/defaults.js';
import { __require as requireEach } from '../../lodash/each.js';
import { __require as requireFilter } from '../../lodash/filter.js';
import { __require as requireFind } from '../../lodash/find.js';
import { __require as requireFlatten } from '../../lodash/flatten.js';
import { __require as requireForEach } from '../../lodash/forEach.js';
import { __require as requireForIn } from '../../lodash/forIn.js';
import { __require as requireHas } from '../../lodash/has.js';
import { __require as requireIsUndefined } from '../../lodash/isUndefined.js';
import { __require as requireLast } from '../../lodash/last.js';
import { __require as requireMap } from '../../lodash/map.js';
import { __require as requireMapValues } from '../../lodash/mapValues.js';
import { __require as requireMax } from '../../lodash/max.js';
import { __require as requireMerge } from '../../lodash/merge.js';
import { __require as requireMin } from '../../lodash/min.js';
import { __require as requireMinBy } from '../../lodash/minBy.js';
import { __require as requireNow } from '../../lodash/now.js';
import { __require as requirePick } from '../../lodash/pick.js';
import { __require as requireRange } from '../../lodash/range.js';
import { __require as requireReduce } from '../../lodash/reduce.js';
import { __require as requireSortBy } from '../../lodash/sortBy.js';
import { __require as requireUniqueId } from '../../lodash/uniqueId.js';
import { __require as requireValues } from '../../lodash/values.js';
import { __require as requireZipObject } from '../../lodash/zipObject.js';

/* global window */

var lodash_1;
var hasRequiredLodash;

function requireLodash () {
	if (hasRequiredLodash) return lodash_1;
	hasRequiredLodash = 1;
	var lodash;

	if (typeof commonjsRequire === "function") {
	  try {
	    lodash = {
	      cloneDeep: requireCloneDeep(),
	      constant: requireConstant(),
	      defaults: requireDefaults(),
	      each: requireEach(),
	      filter: requireFilter(),
	      find: requireFind(),
	      flatten: requireFlatten(),
	      forEach: requireForEach(),
	      forIn: requireForIn(),
	      has:  requireHas(),
	      isUndefined: requireIsUndefined(),
	      last: requireLast(),
	      map: requireMap(),
	      mapValues: requireMapValues(),
	      max: requireMax(),
	      merge: requireMerge(),
	      min: requireMin(),
	      minBy: requireMinBy(),
	      now: requireNow(),
	      pick: requirePick(),
	      range: requireRange(),
	      reduce: requireReduce(),
	      sortBy: requireSortBy(),
	      uniqueId: requireUniqueId(),
	      values: requireValues(),
	      zipObject: requireZipObject(),
	    };
	  } catch (e) {
	    // continue regardless of error
	  }
	}

	if (!lodash) {
	  lodash = window._;
	}

	lodash_1 = lodash;
	return lodash_1;
}

export { requireLodash as __require };
//# sourceMappingURL=lodash.js.map
